import queryString from 'query-string'

export function getUserInformation(component, email) {
    return component.$http({
        url: '/api/crboxwebapi/getinformacion/' +
            email,
        method: 'GET'
    });
}

export function getPackages(component, id_user, fecha_inicial, fecha_final, numero_tracking, estado_tracking) {
    return component.$http({
        url: '/api/crboxwebapi/getuserpackages/' +
            id_user + '/' + fecha_inicial + '/' + fecha_final + '/' + numero_tracking + '/' + estado_tracking,
        method: 'GET'
    });
}
export function getBills(component, email, fecha_inicial, fecha_final) {
    return component.$http({
        url: '/api/crboxwebapi/getfacturas/' +
            email + '/' + fecha_inicial + '/' + fecha_final,
        method: 'GET'
    });
}
export function getBranchOffice(component) {
    return component.$http({
        url: '/api/crboxwebapi/getsucursalescrbox/',
        method: 'GET'
    });
}
export function deletePhone(component, id_user, phone_id) {
    return component.$http({
        url: '/api/crboxwebapi/getdeletephone/' +
            id_user + '/' + phone_id,
        method: 'GET'
    });
}
export function deleteAddress(component, id_user, address_id) {
    return component.$http({
        url: '/api/crboxwebapi/getdeleteaddress/' +
            id_user + '/' + address_id,
        method: 'GET'
    });
}
export function getPurchaseBills(component, warehouseReceiptId) {
    return component.$http({
        url: '/api/crboxwebapi/getpurchasebills/' +
            warehouseReceiptId,
        method: 'GET'
    });
}
export function deletePurchaseBill(component, warehouseReceiptId, email) {
    return component.$http({
        url: '/api/crboxwebapi/getdeletepurchasebill/' +
            warehouseReceiptId + '/' + email,
        method: 'GET'
    });
}
export function postCreatePurchaseBill(component, warehouseReceiptId, textPurchaseBill, billNumber, description, amount, fileLocation) {
    return component.$http({
        url: '/api/crboxwebapi/postcreatepurchasebill',
        data: queryString.stringify({
            WRId: warehouseReceiptId,
            ClientInvoiceText: textPurchaseBill,
            NumeroFactura: billNumber,
            Descripcion: description,
            Monto: amount,
            FileLocation: fileLocation,
        }),
        method: 'POST'
    });
}
export function getUserInfo(component, email) {
    return component.$http({
        url: '/api/crboxwebapi/getuserinfo/' +
            email,
        method: 'GET'
    });
}
export function postEditUser(component, consignee, confirmEmail, password, ConfirmPassword, companyCode, phones, addresses, omitirReceptor) {
    console.log(queryString.stringify({
        'Consignee.IdConsignee' : consignee.idconsignee,
        'Consignee.ConsigneeName': consignee.consigneename,
        'Consignee.ConsigneeLastName1': consignee.consigneelastname1,
        'Consignee.ConsigneeLastName2': consignee.consigneelastname2,
        'Consignee.Email': consignee.email,
        'Consignee.BirthDate': consignee.birthDate,
        'Consignee.IdentificationType': consignee.identificationtype,
        'Consignee.IdentificationNumber': consignee.identificationnumber,
        'Consignee.AlternativeEmail': consignee.alternativeEmail,
        'Consignee.ResidenceCountry': consignee.residenceCountry,
        'Consignee.Sucursal.IdSucursal': consignee.sucursal._idsucursal,
        'Consignee.ContactName1': consignee.contactName1,
        'Consignee.ContactName2': consignee.contactName2,
        'Consignee.IsCompany': consignee.isCompany,
        'Consignee.ReceivesNewsletter': consignee.receivesNewsletter,
        'Consignee.Responsabilidad': consignee.responsabilidad,
        'Consignee.IdResponsabilidad': consignee.idResponsabilidad,
        'ConfirmEmail': confirmEmail,
        'Password': password,
        'ConfirmPassword': ConfirmPassword,
        'CompanyCode': companyCode,
        'Consignee.OmitirReceptor': omitirReceptor,
        Phones: JSON.stringify(phones),
        Addresses: JSON.stringify(addresses),
        }),)
    return component.$http({
        url: '/api/crboxwebapi/postedituser',
        data: queryString.stringify({
            'Consignee.IdConsignee' : consignee.idconsignee,
            'Consignee.ConsigneeName': consignee.consigneename,
            'Consignee.ConsigneeLastName1': consignee.consigneelastname1,
            'Consignee.ConsigneeLastName2': consignee.consigneelastname2,
            'Consignee.Email': consignee.email,
            'Consignee.IdentificationType': consignee.identificationtype,
            'Consignee.IdentificationNumber': consignee.identificationnumber,
            'Consignee.AlternativeEmail': consignee.alternativeEmail,
            'Consignee.ResidenceCountry': consignee.residenceCountry,
            'Consignee.Sucursal.IdSucursal': consignee.sucursal._idsucursal,
            'Consignee.ContactName1': consignee.contactName1,
            'Consignee.ContactName2': consignee.contactName2,
            'Consignee.IsCompany': consignee.isCompany,
            'Consignee.ReceivesNewsletter': consignee.receivesNewsletter,
            'Consignee.Responsabilidad': consignee.responsabilidad,
            'Consignee.IdResponsabilidad': consignee.idResponsabilidad,
            'Consignee.BirthDate': consignee.birthDate,
            'ConfirmEmail': confirmEmail,
            'Password': password,
            'ConfirmPassword': ConfirmPassword,
            'CompanyCode': companyCode,
            'Consignee.OmitirReceptor': omitirReceptor,
            Phones: JSON.stringify(phones),
            Addresses: JSON.stringify(addresses),
            }),
        method: 'POST'
    });
}
export function postRegisterUser(component, consignee, confirmEmail, password, ConfirmPassword, companyCode, phones, addresses) {
    return component.$http({
        url: '/api/crboxwebapi/postregisteruser',
        data: queryString.stringify({
            'Consignee.ConsigneeName': consignee.ConsigneeName,
            'Consignee.ConsigneeLastName1': consignee.ConsigneeLastName1,
            'Consignee.ConsigneeLastName2': consignee.ConsigneeLastName2,
            'Consignee.Email': consignee.Email,
            'Consignee.BirthDate': consignee.BirthDate,
            'Consignee.IdentificationType': consignee.IdentificationType,
            'Consignee.IdentificationNumber': consignee.IdentificationNumber,
            'Consignee.AlternativeEmail': consignee.AlternativeEmail,
            'Consignee.ResidenceCountry': consignee.ResidenceCountry,
            'Consignee.Sucursal.IdSucursal': consignee.IdSucursal,
            'Consignee.ContactName1': consignee.ContactName1,
            'Consignee.ContactName2': consignee.ContactName2,
            'Consignee.IsCompany': consignee.IsCompany,
            'Consignee.ReceivesNewsletter': consignee.ReceivesNewsletter,
            'Consignee.Responsabilidad': consignee.Responsabilidad,
            'Consignee.IdResponsabilidad': consignee.IdResponsabilidad,
            'ConfirmEmail': confirmEmail,
            'Password': password,
            'ConfirmPassword': ConfirmPassword,
            'CompanyCode': companyCode,
            Phones: JSON.stringify(phones),
            Addresses: JSON.stringify(addresses),
            }),
        method: 'POST'
    });
}
export function getPasswordRecovery(component, email) {
    return component.$http({
        url: '/api/crboxwebapi/getuserpasswordrecovery/' +
            email,
        method: 'GET'
    });
}